import { Topic } from "shared/types";

export const useDescendantTopics = (topic: Topic, gender: string) => {
  const topicDescendantTopicsForMale = topic.topicDescendantTopics.filter(
    (t) => t.gender === "male"
  );
  const topicDescendantTopicsForFemale = topic.topicDescendantTopics.filter(
    (t) => t.gender === "female"
  );

  if (
    topicDescendantTopicsForMale.length > 0 &&
    topicDescendantTopicsForFemale.length === 0
  ) {
    return { topicDescendantTopics: topicDescendantTopicsForMale };
  } else if (
    topicDescendantTopicsForFemale.length > 0 &&
    topicDescendantTopicsForMale.length === 0
  ) {
    return { topicDescendantTopics: topicDescendantTopicsForFemale };
  } else if (topic.topicDescendantTopics.length !== 0) {
    return {
      topicDescendantTopics:
        gender === "male"
          ? topicDescendantTopicsForMale
          : topicDescendantTopicsForFemale,
    };
  } else {
    return { topicDescendantTopics: [] };
  }
};
